import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import axios from 'axios';


import 'jquery/dist/jquery.min.js';
//Datatable Modules
import 'datatables.net'
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"
import "datatables.net-buttons/js/dataTables.buttons.js"

import "datatables.net-buttons/js/buttons.flash.js"
import "datatables.net-buttons/js/buttons.html5.js"

import "datatables.net-dt/css/jquery.dataTables.min.css"
import 'datatables.net-responsive-dt'

import $ from 'jquery'

import * as jzip from 'jszip';
window.JSZip = jzip;
const Sensorlist = () => {
    const [sensors, setSensors] = useState([])
    axios.defaults.withCredentials = true;

    const getSensors = async () => {
        const response = await axios.get('https://ayres-iot-backend.cyclic.app/sensors');
        setSensors(response.data)
    }

    const deleteSensor = async (sensorId) => {
        await axios.delete(`https://ayres-iot-backend.cyclic.app/sensors/${sensorId}`)
        getSensors();
    }

    useEffect(() => {
        setTimeout(() => {
            $('#dataTable').DataTable().destroy();
            getSensors();
        }, 2000);
    }, []);

    useEffect(() => {
        $(document).ready(function () {
            $('#dataTable').DataTable(
                {
                    pagingType: 'full_numbers',
                    bLengthChange: false,
                    processing: true,
                    dom: 'Bfrltip',
                    lengthMenu: [
                        [10, 25, 50, -1],
                        ['10 rows', '25 rows', '50 rows', 'Show all'],
                    ],
                    buttons: [
                        {
                            //Tombol untuk Memilih Berpa Banyak Data yang Ditampilkan dalam 1 Halaman
                            extend: 'pageLength',
                            className: 'button is-success is-small is-rounded',
                        },
                        {
                            extend: 'excelHtml5',
                            text: 'Export to Excel',
                            className: 'button is-success is-small is-rounded',
                            titleAttr: 'XLSX',
                            exportOptions: {
                                columns: [1, 2, 3, 4]
                            }
                        },

                    ],
                    bDestroy: true,
                    responsive: true,

                }
            );

        });
    }, [sensors]);







    return (
        <div>
            <section className="hero is-info welcome is-small">
                <div className="hero-body">
                    <div className="container">
                        <h1 className="title">
                            Data
                        </h1>
                        <h2 className="subtitle">
                            List of Data
                        </h2>
                    </div>
                </div>
            </section>

            <div className='box mt-5'>

                <table className='table is-striped is-fullwidth' id="dataTable">
                    <thead>
                        <tr>
                            <th>No</th>
                            <th>Temperature</th>
                            <th>Humidity</th>
                            <th>Created By</th>
                            <th>Date</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sensors.map((sensor, index) =>
                            <tr key={sensor.uuid}>
                                <td>{index + 1}</td>
                                <td>{sensor.temperature}</td>
                                <td>{sensor.humidity}</td>
                                <td>{sensor.user.name}</td>
                                <td>{sensor.createdAt}</td>
                                <td>
                                    <Link to={`/sensors/edit/${sensor.uuid}`} className="button is-small is-success is-rounded mr-2 mt-2">Edit</Link>
                                    <button onClick={() => deleteSensor(sensor.uuid)} className="button is-small is-rounded is-danger my-2">Delete</button>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>

    )
}

export default Sensorlist